import React, { Component } from 'react'
import { string, bool, any, oneOf } from 'prop-types'
import './RTableHeader.css'

export class RTableHeader extends Component {
    static propTypes = {
        type: oneOf(['text', 'empty']).isRequired,
        value: any,
        align: oneOf(['left', 'center', 'right']),
        isHtml: bool,
        isFirstColumn: bool,
        isLastColumn: bool,
        className: string,
    }
    static defaultProps = {
        align: 'left',
        isFirstColumn: true,
        isLastColumn: true,
        className: '',
    }

    renderContent = (type, value, isHtml) => {
        if (type === 'empty') return null
        if (type === 'text' && isHtml) {
            return <span dangerouslySetInnerHTML={{ __html: value }} />
        }
        return <span>{value}</span>
    }

    render() {
        const { type, value, align, isHtml, isFirstColumn, isLastColumn, className, ...otherProps } = this.props
        return (
            <div
                className={['RTableHeader', align, { firstColumn: isFirstColumn }, { lastColumn: isLastColumn }, className]}
                {...otherProps}
            >
                {this.renderContent(type, value, isHtml)}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/RTable/RTableHeader/RTableHeader.js